module.exports = __webpack_public_path__ + "img/goBack_btn_white.fff0566a.svg";